module.exports = __webpack_public_path__ + "static/media/logo.5221db16.svg";